import React from 'react';
import { useQuiz } from '../context/QuizContext';
import ExitConfirmationModal from '../MosaicPSYOPS/ExitConfirmationModal';
import NotificationBell from './NotificationBell';

const DashboardHeaderV2 = () => {
  const { showExitModal, confirmExit, cancelExit } = useQuiz();

  return (
    <>
      <ExitConfirmationModal
        isOpen={showExitModal}
        onContinue={cancelExit}
        onExit={confirmExit}
      />

      <header className="w-full flex items-center justify-between gap-4 px-8 py-4" style={{ backgroundColor: '#1B5A8F' }}>
        <h1 className="text-white text-2xl font-bold">No / SCAM Information Hub</h1>
        <NotificationBell light />
      </header>
    </>
  );
};

export default DashboardHeaderV2;
